import type { CSSProperties } from 'react';

import type { CoinType } from '../../stores/cointype/CoinTypeStore';
import type { GameProviderName } from '../../stores/game/types';

export type TypeParams = {
  color: string;
  giftIcon: string;
};

export type FreeSpinsArgs = {
  rounds: number;
  betAmount: number;
  freeSpinType?: 'AWARDED_FEATURE' | null;
};

export type CountdownArgs = {
  countdownSeconds: number;
  betAmount: number;
  freeSpinType?: 'AWARDED_FEATURE' | null;
};

export type FRBTypeMap = {
  freeSpins: FreeSpinsArgs;
  countdown: CountdownArgs;
};

export type FRBType = keyof FRBTypeMap;

export type BaroulettaMaxPrize =
  | {
      type: 'rounds';
      showMaxPrize?: boolean;
      useMeta?: boolean;
    }
  | {
      amount: number;
      type: 'coins';
      coinType: 'GC' | 'SC';
      showMaxPrize?: boolean;
      useMeta?: boolean;
    };

export type FRBWidgetArgs<T extends FRBType> = {
  provider?: GameProviderName;
  type: T;
  coinType: CoinType;
  gameImage: string;
  width?: CSSProperties['width'];
  height?: CSSProperties['height'];
  className?: string;
  dataTestId?: string;
  maxPrize?: BaroulettaMaxPrize;
  rounds?: number;
  displayCount?: number;
  fontSize?: number;
  usePropFontSize?: boolean;
} & FRBTypeMap[T];

export type FRBWidgetProps = {
  [K in keyof FRBTypeMap]: FRBWidgetArgs<K>;
}[keyof FRBTypeMap];

export function isFreeSpinsType(args: FRBWidgetProps): args is FRBWidgetArgs<'freeSpins'> {
  return args.type === 'freeSpins';
}

export function isCountdownType(args: FRBWidgetProps): args is FRBWidgetArgs<'countdown'> {
  return args.type === 'countdown';
}
